import React, {useRef} from 'react'
import styled from "styled-components";
import {media} from "../styles/MediaMixins";
import fb from '../../img/blog/facebook-logo.svg'
import tw from '../../img/blog/twitter-logo.svg'
import li from '../../img/blog/linkedin-logo.svg'
import sh from '../../img/blog/copy-link-logo.svg'
import {FacebookShareButton, LinkedinShareButton, TwitterShareButton} from "react-share";
import ShowToast from "../toast/ShowToast";

const SingleShare = styled.div`
    display: flex;
    width: ${88 / 16}rem;
    height: ${78 / 16}rem;
    ${props => props.border && `border-bottom: 1px solid white`};
    button {
        margin: auto;
        width: 100%;
        height: 100%;
    }
`

const Container = styled.div`
    left: -${68 / 16}rem;
    width: ${88 / 16}rem;
    display: flex;
    flex-direction: column;
    ${media.touch`display: none`};
    ${media.desktop`position: fixed`};
    &:hover {
      background-color: #D8D8D8;
        left: 0;
    }
    top: calc(50% - 8rem);
    background-color: #D8D8D880;
    z-index: 200;
    transition: transform 0.3s ease 0s, left 0.3s ease 0.1s, opacity 0.3s ease 0.1s, box-shadow 0.3s ease 0s, background-color 0.3s ease 0s;
    -o-transition: transform 0.3s ease 0s, left 0.3s ease 0.1s, opacity 0.3s ease 0.1s, box-shadow 0.3s ease 0s, background-color 0.3s ease 0s;
    -moz-transition: transform 0.3s ease 0s, left 0.3s ease 0.1s, opacity 0.3s ease 0.1s, box-shadow 0.3s ease 0s, background-color 0.3s ease 0s;
    -webkit-transition: transform 0.3s ease 0s, left 0.3s ease 0.1s, opacity 0.3s ease 0.1s, box-shadow 0.3s ease 0s, background-color 0.3s ease 0s;
`

const CopyButton = styled.button`
    border: none;
    cursor: pointer;
    background: transparent;
`

export default ({location}) => {
    const clipboard = useRef();
    const handleCopy = () => {
        if (document) {
            const selected =
                document.getSelection().rangeCount > 0
                    ? document.getSelection().getRangeAt(0)
                    : false;
            clipboard.current.select();
            document.execCommand('copy');
            if (selected) {
                document.getSelection().removeAllRanges();
                document.getSelection().addRange(selected);
            }
            ShowToast('success', `Link has been copied to clipboard`);
        }
    };
    return (
        <Container>
            <input style={{position: 'absolute', left: '-9999px'}} ref={clipboard} defaultValue ={location.href} readOnly={true}/>
            <SingleShare border={true}>
                <FacebookShareButton url={location.href}>
                    <img src={fb} alt={'Facebook icon'}/>
                </FacebookShareButton>
            </SingleShare>
            <SingleShare border={true}>
                <TwitterShareButton url={location.href}>
                    <img src={tw} alt={'Twitter icon'}/>
                </TwitterShareButton>
            </SingleShare>
            <SingleShare border={true}>
                <LinkedinShareButton url={location.href}>
                    <img src={li} alt={'LinkedIn icon'}/>
                </LinkedinShareButton>
            </SingleShare>
            <SingleShare>
                <CopyButton onClick={handleCopy}>
                    <img src={sh} alt={'Copy Link icon'}/>
                </CopyButton>
            </SingleShare>
        </Container>
    )
}